var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { sortMemberGroupsByBindings } from "./planner.js";
import { renderOp } from "./render.js";
function renderStatement(payload, options) {
    const sql = renderOp(payload, options);
    if ((options === null || options === void 0 ? void 0 : options.aliasMode) !== true || options.aliases === undefined)
        return sql;
    const defs = options.aliases.drainDefinitions();
    return defs.length > 0 ? `${defs.join('\n')}\n${sql}` : sql;
}
export function dumpObject(object_1) {
    return __awaiter(this, arguments, void 0, function* (object, options = {}) {
        var _a, e_1, _b, _c;
        const statements = [];
        const dag = yield object.getScopedDag();
        try {
            for (var _d = true, _e = __asyncValues(dag.loadAllEntries()), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                _c = _f.value;
                _d = false;
                const entry = _c;
                const rendered = renderStatement(entry.payload, Object.assign({ at: entry.header.prevEntryHashes }, options.render));
                if (options.includeUnknown === false && rendered.startsWith('-- unknown payload'))
                    continue;
                statements.push(rendered);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return statements.join('\n\n');
    });
}
export function dumpSchema(schema, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const name = schema.getName();
        return dumpObject(schema, Object.assign(Object.assign({}, options), { render: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.render), { schemaRef: schema.getId(), schemaName: name, versionScope: { objectId: schema.getId(), objectName: name } }) }));
    });
}
export function dumpGroup(group, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const groupId = group.getId();
        const groupName = group.getName();
        return dumpObject(group, Object.assign(Object.assign({}, options), { render: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.render), { schemaRef: group.getSchemaRef(), groupRef: groupId, groupName, versionScope: { objectId: groupId, objectName: groupName } }) }));
    });
}
export function dumpDatabaseCreate(db, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const dag = yield db.getScopedDag();
        const entry = yield dag.loadEntry(db.getId());
        if (entry === undefined)
            throw new Error('RDb genesis entry not found');
        const databaseName = databaseNameFromPayload(entry.payload);
        return renderStatement(entry.payload, Object.assign(Object.assign({}, options.render), { versionScope: { objectId: db.getId(), objectName: databaseName } }));
    });
}
export function dumpDatabaseAddSchemas(db, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return dumpRDbMembershipOps(db, 'add-schema', options);
    });
}
export function dumpDatabaseAddGroups(db, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return dumpRDbMembershipOps(db, 'add-group', options);
    });
}
function dumpRDbMembershipOps(db, action, options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, e_2, _b, _c;
        const statements = [];
        const dag = yield db.getScopedDag();
        const genesis = yield dag.loadEntry(db.getId());
        const databaseName = genesis === undefined ? 'database' : databaseNameFromPayload(genesis.payload);
        const versionScope = { objectId: db.getId(), objectName: databaseName };
        try {
            for (var _d = true, _e = __asyncValues(dag.loadAllEntries()), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                _c = _f.value;
                _d = false;
                const entry = _c;
                if (entry.hash === db.getId())
                    continue;
                const payload = entry.payload;
                if (payload['action'] !== action)
                    continue;
                statements.push(renderStatement(entry.payload, Object.assign({ at: entry.header.prevEntryHashes, versionScope }, options.render)));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return statements.join('\n\n');
    });
}
export function dumpGroupEntry(group, entryHash, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const dag = yield group.getScopedDag();
        const entry = yield dag.loadEntry(entryHash);
        if (entry === undefined)
            return undefined;
        const groupId = group.getId();
        const groupName = group.getName();
        return renderStatement(entry.payload, Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.render), { schemaRef: group.getSchemaRef(), groupRef: groupId, groupName, versionScope: { objectId: groupId, objectName: groupName }, at: entry.header.prevEntryHashes }));
    });
}
export function dumpGroupCreate(group, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const rendered = yield dumpGroupEntry(group, group.getId(), options);
        if (rendered === undefined)
            throw new Error('Tablegroup genesis entry not found');
        return rendered;
    });
}
function databaseNameFromPayload(payload) {
    var _a;
    if (typeof payload !== 'object' || payload === null || Array.isArray(payload))
        return 'database';
    const create = payload;
    return (_a = create.name) !== null && _a !== void 0 ? _a : create.seed;
}
export function dumpDatabase(db, options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const profile = (_a = options.mode) !== null && _a !== void 0 ? _a : 'full';
        const schemaIds = yield db.getMemberSchemas();
        const groupIds = yield sortMemberGroupsByBindings(yield db.getMemberGroups(), options.loadGroup);
        const schemaNames = new Map();
        for (const id of schemaIds) {
            const schema = yield options.loadSchema(id);
            schemaNames.set(id, schema.getName());
        }
        const groupNames = new Map();
        for (const id of groupIds) {
            const group = yield options.loadGroup(id);
            groupNames.set(id, group.getName());
        }
        const dag = yield db.getScopedDag();
        const genesis = yield dag.loadEntry(db.getId());
        const databaseName = genesis === undefined ? 'database' : databaseNameFromPayload(genesis.payload);
        const renderOpts = Object.assign({ profile,
            databaseName, resolveSchemaName: (id) => schemaNames.get(id), resolveGroupName: (id) => groupNames.get(id) }, options.render);
        const dumpOpts = Object.assign(Object.assign({}, options), { render: renderOpts });
        const sections = [];
        sections.push(yield dumpDatabaseCreate(db, dumpOpts));
        for (const schemaId of schemaIds) {
            const schema = yield options.loadSchema(schemaId);
            const schemaName = schema.getName();
            sections.push(yield dumpSchema(schema, Object.assign(Object.assign({}, options), { render: Object.assign(Object.assign({}, renderOpts), { schemaRef: schemaId, schemaName, versionScope: { objectId: schemaId, objectName: schemaName } }) })));
        }
        const addSchemas = yield dumpDatabaseAddSchemas(db, dumpOpts);
        if (addSchemas.length > 0)
            sections.push(addSchemas);
        for (const groupId of groupIds) {
            const group = yield options.loadGroup(groupId);
            const schemaName = schemaNames.get(group.getSchemaRef());
            const groupName = group.getName();
            const groupRender = Object.assign(Object.assign({}, renderOpts), { schemaRef: group.getSchemaRef(), schemaName, groupRef: groupId, groupName, versionScope: { objectId: groupId, objectName: groupName } });
            if (profile === 'full') {
                sections.push(yield dumpGroup(group, Object.assign(Object.assign({}, options), { render: groupRender })));
            }
            else {
                sections.push(yield dumpGroupCreate(group, Object.assign(Object.assign({}, options), { render: groupRender })));
            }
        }
        const addGroups = yield dumpDatabaseAddGroups(db, dumpOpts);
        if (addGroups.length > 0)
            sections.push(addGroups);
        return sections.filter((s) => s.length > 0).join('\n\n');
    });
}
